import type { DescriptionProp } from '@/base-ui/descriptions'
export const dependencies: DescriptionProp[] = [
  {
    name: 'vue',
    description: '^3.0.5'
  },
  {
    name: 'vue-router',
    description: '^4.0.6'
  },
  {
    name: 'vuex',
    description: '^4.0.0'
  },
  {
    name: 'axios',
    description: '^0.21.1'
  },
  {
    name: 'element-plus',
    description: '^1.0.2-beta.41'
  },

  {
    name: 'mockjs',
    description: '^1.1.0'
  },

  {
    name: 'less',
    description: '^4.1.1'
  },
  {
    name: 'scss',
    description: '^0.2.4'
  },
  {
    name: 'EChart',
    description: '^5.1.1'
  },

  {
    name: '@vueuse/core',
    description: '^4.9.1'
  },
  {
    name: 'countup.js',
    description: '^2.0.7'
  },
  {
    name: 'dayjs',
    description: '^1.10.4'
  },
  {
    name: 'pinia',
    description: '^2.0.0-alpha.13'
  },
  {
    name: 'wangeditor',
    description: '^4.6.17'
  }
]
